import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { LoaderService } from 'app/infrastructure/services/loader.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { StandardDictionaryService } from 'app/infrastructure/services/standarddictionary.service';
import { StandardDictionary } from 'app/infrastructure/model/interfaces/standarddictionary.interface';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
    selector: 'sx-detail-standard-dictionary',
    templateUrl: './detail-standard-dictionary.component.html',
})
export class DetailStandardDictionaryComponent implements OnInit {
    isNew = false;
    isLoading = false;
    checkeandCodigo = false;
    errors: any = [];
    editable = false;
    checked = false;
    codStandarDictionary: string;
    standardDictionary: StandardDictionary = {
        id: null,
        name: null,
        description: null,
        jsonFile: null,
        category: {
            idCategory: null,
            organizationCode: null
        },
        categories: null
    };

    options: any = { maxLines: 1000, printMargin: true };

    constructor(
        private standardDictionaryService: StandardDictionaryService,
        private alertService: AlertService,
        public loader: LoaderService,
        private sxTranslationService: SxTranslationService,
        private router: Router,
        private aRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params) => {
            this.codStandarDictionary = params["codstandarddictionary"];
            if (this.codStandarDictionary === undefined) {
                this.isNew = true;
                this.organizations();
            }
            else {
                this.standardDictionaryService.getById(this.codStandarDictionary).subscribe((data) => {
                    if (!data) return this.router.navigateByUrl("/soc/404");
                    this.standardDictionary = data;
                    this.standardDictionary.jsonFile = JSON.stringify(JSON.parse(this.standardDictionary.jsonFile), null, 2);
                });
            }
        });
    }
    organizations() {
        this.standardDictionaryService.getCategory().subscribe((res) => {
            this.standardDictionary.categories = res;
        });
    }

    save() {
        if (this.validar()) {
            this.checkeandCodigo = true;
            this.standardDictionaryService.create(this.standardDictionary).then((res) => {
                if (res) {
                    this.alertService.showGrowl({
                        type: GrowlType.SUCCESS,
                        body: "DICTIONARY_UPDATED"
                    });

                    this.router.navigate(['../'], { relativeTo: this.aRoute });
                } else {
                    this.alertService.showGrowl({
                        type: GrowlType.DANGER,
                        body: "ERROR"
                    });
                }
            });
        }
    }
    validar() {
        this.errors = [];

        if (!this.standardDictionary.category) {
            this.errors['organization'] = this.sxTranslationService.getResource("ORGANIZATION_SELECT");
            return false;
        }
        else if (!this.standardDictionary.name || this.standardDictionary.name.length <= 0) {
            this.errors['name'] = this.sxTranslationService.getResource("AL_MENOS_1_CARACTER");
            return false;
        }
        else if (this.standardDictionary.name.length > 30) {
            this.errors['name'] = this.sxTranslationService.getResource("MAX_LONGITUD", { max: 30 });
            return false;
        }
        else if (this.standardDictionary.name === "NEW") {
            this.errors['name'] = this.sxTranslationService.getResource("INVALID_NAME");
            return false;
        }
        else if (!this.standardDictionary.jsonFile || this.standardDictionary.jsonFile.length <= 0) {
            this.errors['json'] = this.sxTranslationService.getResource("AL_MENOS_1_CARACTER");
            return false;
        }
        else {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/standard-dictionary/detail/detail-standard-dictionary.component.ts